import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ReviewUpdateForm from './ReviewUpdateForm';
import { api } from '../services/api';
import SatisfactionSelection from './SatisfactionSelection';

function UpdateFormWrapper({ toast, user }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const { surgery } = useParams();
  const [currentStep, setCurrentStep] = useState(1);
  const [totalSteps, setTotalSteps] = useState(2);
  const [formData, setFormData] = useState({
    rating: null,
    description: ''
  })

  const onContinue = () => {
    setCurrentStep((prevStep) => prevStep + 1)
  }

  const handleBack = () => {
    setCurrentStep(prev => prev - 1);
  };

  const onCancel = async () => {
    navigate('/surgeries')
  };
  useEffect(() => {
    if (!user) {
      navigate('/surgeries');
    }
  }, [navigate]);

  useEffect(() => {
    if (id) {
      api.getUpdate(id)
        .then(res => {
          setFormData({
            rating: res.rating,
            description: res.description
          })
        })
    }
  }, [])
  return (
    <div className="form-container review-update-container">
      {currentStep === 1 && (
        <SatisfactionSelection
          onContinue={onContinue}
          currentStep={currentStep}
          totalSteps={totalSteps}
          onBack={handleBack}
          onCancel={onCancel}
          formData={formData}
          setFormData={setFormData}
        />
      )}
      {currentStep == 2 && (
        <ReviewUpdateForm
          id={id}
          surgery={surgery}
          onCancel={onCancel}
          currentStep={currentStep}
          totalSteps={totalSteps}
          formData={formData}
          setFormData={setFormData}
          toast={toast}
          onBack={handleBack}
        />
      )}
    </div>
  )
}

export default UpdateFormWrapper;